import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FullscreenEnterFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9.87999 19V17.36H6.71999C6.01999 17.36 5.49999 16.84 5.49999 16.14V13.08H3.85999V16.24C3.85999 18 4.85999 19 6.61999 19H9.87999ZM14.12 19H17.38C19.14 19 20.14 18 20.14 16.24V13.08H18.5V16.14C18.5 16.84 17.98 17.36 17.28 17.36H14.12V19ZM9.87999 5H6.61999C4.85999 5 3.85999 6 3.85999 7.76V10.92H5.49999V7.86C5.49999 7.16 6.01999 6.64 6.71999 6.64H9.87999V5ZM14.12 5V6.64H17.28C17.98 6.64 18.5 7.16 18.5 7.86V10.92H20.14V7.76C20.14 6 19.14 5 17.38 5H14.12Z"
      />
    </SvgIcon>
  );
});
